import React from 'react';

import { useNetworkStatusNotification } from './hooks';
import { NotificationView } from './NotificationView';

export const NetworkStatusChecker: React.FC = () => {
  const { isOfflineModalVisible } = useNetworkStatusNotification();

  return <NotificationView show={isOfflineModalVisible} />;
};
